import { MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS, ICONS_WEB } from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Box, Typography } from "@mui/material";

export function BoxedQuantityControl({
  isDecreaseDisabled,
  isIncreaseDisabled,
  onDecreaseQty,
  onIncreaseQty,
  quantity,
}) {
  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      sx={{
        border: 1,
        borderStyle: "solid",
        borderRadius: 1,
      }}
    >
      <MiButton
        variant={BUTTON_VARIANTS.TEXT}
        startIcon={{ path: mdi[ICONS_WEB.MINUS], iconSize: 1 }}
        onClick={onDecreaseQty}
        disabled={isDecreaseDisabled}
      />
      <Typography>{quantity}</Typography>
      <MiButton
        variant={BUTTON_VARIANTS.TEXT}
        startIcon={{ path: mdi[ICONS_WEB.PLUS], iconSize: 1 }}
        onClick={onIncreaseQty}
        disabled={isIncreaseDisabled}
      />
    </Box>
  );
}
